import Service from '@ember/service';

import { service } from '@ember/service';

const matchProtocol = /^[^/]+:\/\//;
const matchOnlyProtocol = /^[^/]+:\/\/$/;
const matchProtocolHostAndPort =
  /^((?:[^/]+:\/\/)?(?:[^:]+:[^:@]@)?[^/:]+)(:[0-9]+)?/;

export default class ApiHostBuilderService extends Service {
  @service ssr;

  build(host, port, defaultProtocol = null) {
    const { location = {
      host: this.ssr.request.host,
      protocol: this.ssr.request.protocol
    } } = globalThis;
    if (!host || matchOnlyProtocol.test(host)) {
      host = (host || '') + location.host;
    }
    if (!matchProtocol.test(host)) {
      let protocol = defaultProtocol || location.protocol;
      if (!protocol.endsWith('//')) {
        protocol += protocol.endsWith(':') ? '//' : '://';
      }
      host = protocol + host;
    }
    if (port) {
      host = host.replace(
        matchProtocolHostAndPort,
        '$1' + (+port === 80 ? '' : ':' + port)
      );
    }
    return host;
  }
}
